export enum MilestoneNaStatus {
  ALWAYS_APPLICABLE = 'ALWAYS_APPLICABLE',
  APPLICABLE = 'APPLICABLE',
  NOT_APPLICABLE = 'NOT_APPLICABLE',
}
